import React,{useState, useEffect} from 'react';
import ReactApexChart from 'react-apexcharts';
import { useScreeningTimelineStatusCandidatewiseMutation } from '../../features/dashboard/dashboardApiSlice';
import { useInterviewTimelineStatusCandidatewiseMutation } from '../../features/dashboard/dashboardApiSlice';
import SelectCountryListByLocation from '../../features/utils/SelectCountryListByLocation';
import { cleanObjectData } from '../../features/utils/Utils';

const BubbleChart = () => {
  const [selectedCountryId, setSelectedCountryId] = useState(0);
  const [selectedLocationId, setSelectedLocationId] = useState(0);
  const [selectedBranchId, setSelectedBranchId] = useState(0);

  const [currentPage, setCurrentPage] = useState(1); //current page
  const itemsPerPage = 5; //Items per page

const [interviewTimelineChart, {data: interviewTimelineCandidatewiseData}] = useInterviewTimelineStatusCandidatewiseMutation();
console.log('interviewData',interviewTimelineCandidatewiseData);

  useEffect(() => {
    callAPI();
  }, []);

  useEffect(() => {
    callAPI();
  }, [selectedCountryId, selectedLocationId, selectedBranchId]);


  const callAPI = () => {
    const data = {
      country_id: parseInt(selectedCountryId),
      location_id: parseInt(selectedLocationId),
      branch_id: parseInt(selectedBranchId),
    };
    const dataObj = cleanObjectData(data);
    interviewTimelineChart(dataObj);
  };

// const chartData = screeningTimelineCandidatewiseData?.data || [] ;
const chartData = interviewTimelineCandidatewiseData?.data || [];

  const chartName = 'Interview Timeline Report'

  console.log(chartData);

  // Convert data to the format required by ApexCharts
//   const categoriesX = [...new Set(chartData.map(item => item.sourced))];
//   console.log(categoriesX);
//   const categoriesY = [...new Set(chartData.map(item => item.job_request_title))];
//   console.log(categoriesY);
//   const categoriesZ = [...new Set(chartData.map(item => item.Taskstatus))];
//   console.log(categoriesZ);

// const extractDays = (status) => {
//     const match = status.match(/(-?\d+)\s+days/); // Extract the numeric part
//     return match ? parseInt(match[1], 10) : 0;   // Default to 0 if no match
//   };
  
  const categoriesX = [...new Set(chartData.map(item => item.TaskStatus))];
  console.log(categoriesX);
  const categoriesY = [...new Set(chartData.map(item => item.fullName))];
  console.log(categoriesY);
  const categoriesZ = [...new Set(chartData.map(item => item.TaskOverdueDays))];
  console.log(categoriesZ);

//   const seriesData = chartData.map(item => ({
//     x: categoriesX.indexOf(item.sourced),
//     y: categoriesY.indexOf(item.job_request_title),
//     z: Number(item.sourced)
//   }));
const seriesData = chartData.map((item) => {
    // let fillColor;
    // switch (item.Taskstatus) {
    //   case 'On Track':
    //     fillColor = '#42DE56'; 
    //     break;
    //   case 'Overdue':
    //     fillColor = '#FEC310'; 
    //     break;
    //   case 'At Risk':
    //     fillColor = '#FE2B4C';
    //     break;
    // //   default:
    // //     fillColor = '#CCCCCC'; 
    // }
  
    // return {
    //   x: categoriesX.indexOf(item.sourced),
    //   y: categoriesY.indexOf(item.job_request_title),
    //   z: categoriesZ.indexOf(item.Taskstatus),
    //   fillColor: fillColor,
    // };
    // const days = extractDays(item.TaskStatus);
    let fillColor;
    if (item.TaskStatus.includes('On Track')) fillColor = '#42DE56';
  else if (item.TaskStatus.includes('Overdue')) fillColor = '#FE2B4C';
  else fillColor = '#FEC310';
  const overdueDays = item.TaskOverdueDays !== null ? item.TaskOverdueDays : 0;

  return {
    x: categoriesX.indexOf(item.TaskStatus), // Map TaskStatus to x-axis
    y: categoriesY.indexOf(item.fullName),  // Map fullName to y-axis
    z: overdueDays,                         // Use adjusted TaskOverdueDays value
    fillColor,                              // Color based on status
  };
  });
  

  const options = {
    chart: {
      height: 350,
      type: 'bubble',
      fontFamily: 'Inter var', // Set font family for all text elements
      foreColor: '#000000', // Set color for all text elements to black
      toolbar: {
        show: false, // Hide the toolbar (menu bar)
      },
    },
    // dataLabels: {
    //   enabled: false
    // },
    dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          const dataIndex = opts.dataPointIndex; // Get the index of the data point
          return chartData[dataIndex]?.sourced || ''; // Display the 'sourced' value
        },
        style: {
          colors: ['#ffffff'], // White color for the text inside the bubble
          fontSize: '12px', // Adjust font size as needed
          fontWeight: 'bold', // Optional: make the text bold
        },
        background: {
          enabled: true,
          foreColor: '#000', // Background text color
          borderRadius: 4,
          padding: 4,
          opacity: 0.8,
        },
      },
      
    xaxis: {
      // categories: categoriesX,
      labels: {
        formatter: (value) => categoriesX[value], // Adjust index for display
        show: true,
      },
      min: -0.5, // Add extra space on the left side
      max: categoriesX.length - 0.5, // Add extra space on the right side
      axisBorder: {
        show: true,
        color: '#9ca3af', //color of x-axis line
        height: 1,
      },
      axisTicks: {
        show: false,
        // color: '#6234C1', //color of x-axis ticks
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => categoriesY[value], // Adjust index for display
      },
      min: -0.5, // Add extra space on the bottom side
      max: categoriesY.length - 0.5, // Add extra space on the top side
      axisBorder: {
        show: true,
        color: '#9ca3af', //color of x-axis line
        width: 1,
      },
    },
    grid: {
      show: true,
      borderColor: '#f3f4f6',
      xaxis: {
        lines: {
          show: false, // Show vertical grid lines
        },
      },
      yaxis: {
        lines: {
          show: false, // Show horizontal grid lines
        },
      },
    },
    plotOptions: {
      bubble: {
        minBubbleRadius: 18, // Minimum bubble size
        maxBubbleRadius: 18  // Maximum bubble size
      }
    },
    tooltip: {
        custom: ({ seriesIndex, dataPointIndex, w }) => {
          const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
          const overdueDays = chartData[dataPointIndex]?.TaskOverdueDays ?? 0;
          return `
            <div style="padding: 5px;">
              <strong>${categoriesY[data.y]}</strong><br>
              <span>Status: ${categoriesX[data.x]}</span><br>
              <span>Timeline: ${overdueDays} days</span>
            </div>
          `;
        },
      },
  };

  const series = [{
    name: 'name',
    data: seriesData
  }];

  

  const setCountryId = (id) => {
    setSelectedCountryId(id);
  };

  const setLocationId = (id) => {
    setSelectedLocationId(id);
  };

  const setBranchId = (id) => {
    setSelectedBranchId(id);
  };

  return (
    <div>
      <div className="flex justify-between p-3">
        <div>
          <h1 className="text-black text-[16px] font-sans">{chartName}</h1>
        </div>
        <div>
          <SelectCountryListByLocation
            setCountryId={setCountryId}
            setLocationId={setLocationId}
            setBranchId={setBranchId}
            isDaysFilter={false}
            showCountry={true}
            showBranch={true}
            showLocation={true}
          />
        </div>
      </div>
      <ReactApexChart
        type="bubble"
        series={series}
        options={options}
        width={567}
        height={380}
      />
    </div>
  );
};

export default BubbleChart;



